/*
* Created on Feb 04, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

export const DEFAULT_SIZE_LIST = ['1', '2~4', '5~9', '10~24', '25~49', '50~249', '250~999', '1000+']
export const CONTACT_TYPE_MAP = {myqnapcloud: 'myQNAPcloud', google: 'Google'};
export const SUPPORTED_LANGUAGES = [
    { value: "en", "name": "English", "en_name": "English"},
    { value: "zh_TW", "name": "繁體中文", "en_name": "Traditional Chinese"},
    { value: "zh", "name": "简体中文", "en_name": "Simplified Chinese"},
    { value: "cs", "name": "Czech", "en_name": "Czech"},
    { value: "da", "name": "Dansk", "en_name": "Danish"},
    { value: "de", "name": "Deutsch", "en_name": "German"},
    { value: "es", "name": "Español", "en_name": "Spanish"},
    { value: "fr", "name": "Français", "en_name": "French"},
    { value: "it", "name": "Italiano", "en_name": "Italian"},
    { value: "ja", "name": "日本語", "en_name": "Japanese"},
    { value: "ko", "name": "한국", "en_name": "Korean"},
    { value: "no", "name": "Norsk", "en_name": "Norwegian"},
    { value: "pl", "name": "Polski", "en_name": "Polish"},
    { value: "ru", "name": "Русский", "en_name": "Russian"},
    { value: "fi", "name": "Suomi", "en_name": "Finnish"},
    { value: "sv", "name": "Svenska", "en_name": "Swedish"},
    { value: "nl", "name": "Nederlands", "en_name": "Dutch"},
    { value: "tr", "name": "Turk dili", "en_name": "Turkish"},
    { value: "th", "name": "ไทย", "en_name": "Thai"},
    { value: "pt", "name": "Português", "en_name": "Portuguese"},
    { value: "hu", "name": "Magyar", "en_name": "Hungarian"},
    { value: "el", "name": "Ελληνικά", "en_name": "Greek"},
    { value: "ro", "name": "Român", "en_name": "Romanian"}
]


// Format Validation Formats
export const ORGANIZATION_NAME_FORMAT = /^[a-zA-Z0-9][^,;]{0,99}$/;
// export const EMAIL_FORMAT = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$";
export const EMAIL_FORMAT = "^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,63}$";
export const PHONE_FORMAT = /^[0-9]{6,15}$/
export const LENGTH_FORMAT = (length) => `^.{1,${length}}$`;
export const GROUP_DESCRIPTION_FORMAT = (min, max) => `^.{${min},${max}}$`;

// `list` is the canonical list from CountryListContext.
export const getCountryList = (region, list) => {
    return (list || []).map(elem => {
        if (region === 'CHINA') {
            if (elem === 'Hong Kong' || elem === 'Taiwan') {
                return `${elem}, China`;
            }
        }
        return elem;
    });
};

export const convertToQNAPLang = (lang) => {
    switch (lang) {
        case 'zh_TW':
            return 'zh-tw';
        case 'zh':
            return 'zh-cn';
        case 'de':
            return 'de-de';
        case 'es':
            return 'es-es';
        case 'fr':
            return 'fr-fr'
        case 'it':
            return 'it-it'
        case 'nl':
            return 'nl-nl'
        case 'sv':
            return 'sv-se'
        case 'pt':
            return 'pt-pt'
        case 'pl':
            return 'pl-pl'
        case 'ja':
            return 'ja-jp'
        case 'ko':
            return 'ko-kr'
        case 'cs':
            return 'cs-cz'
        case 'th':
            return 'th-th'
        case 'tr':
            return 'tr-tr'
        case 'hu':
            return 'hu-hu'
        case 'da':
            return 'da-dk'
        default:
            return 'en';
    }
}

// common used functions
export const isAsync = (method) => {
    return method.constructor.name === 'AsyncFunction';
}

export const funcWrapper = async (func) => {
    try {
        if (isAsync(func)) {
            await func();
            alert(true, 'success', 'Success');
        } else {
            // onSubmit();
            // Promise.resolve(onSubmit()).then(data=>{
            //     alert(true, 'success', 'Success');
            // }).catch(err=>{
            //     alert(true, 'error', err.message);
            // });
            if (typeof func.then == 'function') {
                func().then(data => {
                    alert(true, 'success', 'Success');
                }).catch(err => {
                    alert(true, 'error', err.message);
                });
            } else {
                func();
            }
        }
    } catch (err) {
        alert(true, 'error', err.message);
    }
}

export const get_primary_email = (user) => {
    if (user) {
        return user?.emails?.filter(e=>e.is_primary && e.is_verified)[0]?.email;
    }
    return '';
}

export const convert_error_code = (error_code, message=null) => {
    // const code = parseInt(error_code);
    if (error_code_base?.[error_code]) {
        return error_code_base[error_code];
    }
    else if (message)
        return `@${message}@`;
    return '@Unknown Error@';
}

export const error_code_base = {
    1050001: "@User not found@",
    1050002: "@User already exist@",
    1050020: "@User already exist@",
    1050003: "@User already exist@",
    1050005: "@Incorrect password@",
    1050006: "@Account has been activated@",
    1050009: "@Unsupported image type@",
    1050010: "@Cannot read image file@",
    1000001: "@System busy please try again later@",
    1004006: "@User already exist@",
    1000003: "@Email format incorrent.@",
    1000004: "@Fail to send request to server@",
    1007004: "@Invitation not found.@",
    1019010: "@It looks like you have tried too many times. Try again later.@",
    1060000: "@Unable to perform action due to insufficient permission.@",
    1060001: "@Unable to create Organization.@",
    1060002: "@Organization name {org_name} is already taken.@",
    1060003: "@Organization not found or Invalid Organization ID.@",
    1060004: "@Permission denied. Need to be owner to complete the operation.@",
    1060005: "@User(s) does not exists in the Organization.@",
    1060006: "@Cannot delete self as a owner of the organization.@",
    1060007: "@Cannot delete the only owner in organization.@",
    1060008: "@Unable to create Organization Group.@",
    1060009: "@Organization group name {group_name} is already taken.@",
    1060010: "@Organization max owner number reached.@",
    1060011: "@Organization needs to have at least one owner.@",
    1060012: "@User already exists in the Organization.@",
    1060013: "@Missing Organization ID or invalid token.@",
    1060014: "@User does not have an email in the profile.@",
    1060015: "@Invalid Group ID or Group not found.@",
    1060016: "@The requested organization id does not match with the current token Organization Id@",
    1060017: "@The token contains neither Organization ID nor User info.@",
    1060018: "@Site duplicate@",
    1060019: "@Invalid Site ID or Site not found.@",
    1060020: "@User were not in the Organization.@",
    1060021: "@Group were not in the Organization.@",
    1060022: "@You cannot suspend your own account from the owner group.@",
    1060023: "@This operation is invalid! This might be because your organization has been deleted or you are coming from an expired confirmation email.@",
    1060033: "@You have reached the maximum limit of 50 organizations for your QNAP ID.@",
    1060034: "@This organization has reached the maximum limit of 1000 user accounts.@",
    1060035: "@This organization has reached the maximum limit of 100 groups.@",
    1060036: "@This organization has reached the maximum limit of 100 sites.@",
    'org_owner_should_be_added_first': "@Assign an organization owner to this region before adding seats for members.@"
}

export const isValidCountry = (value, list) => {
    if (value === '' || value === undefined || value === null) return true; // optional field
    return Array.isArray(list) && list.includes(value);
};